import type { Flatpage } from '@features/flatpages/types'
import type { FlatpageDto } from '@shared/api/flatpages.dto'

/** Преобразует backend DTO простой страницы в доменную модель. */
export const mapFlatpageDto = (dto: FlatpageDto): Flatpage => ({
  content: dto.content,
  title: dto.title,
  seoTitle: dto.seo_title || null,
  seoDescription: dto.seo_description || null,
  seoKeywords: dto.seo_keywords || null,
  url: dto.url,
})
